import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/store";
import Logo from "../../assets/ditella-logo.png";
import {
  selectSidebarOpen,
  setLoadingPageScreen,
} from "../../features/Dashboard/Slices/dashboardSlice";
import { conf } from "../../utils/config";
import "./Sidebar.css";
var pjson = require("../../../package.json");
console.log(pjson.version);
interface SubMenuItem {
  icon: string;
  label: string;
  route: string;
  active: boolean;
}

interface MenuItem {
  icon: string;
  label: string;
  route?: string;
  active: boolean;
  subitems?: SubMenuItem[];
}

const entorno = conf("ENV");
const version = pjson.version;

function Sidebar() {
  const sidebarOpen = useSelector(selectSidebarOpen);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [expandedItems, setExpandedItems] = useState<{
    [key: number]: boolean;
  }>({});

  useEffect(() => {
    dispatch(setLoadingPageScreen(false));
  }, [location]);

  const navigate = useNavigate();
  const isSubrouteActive = (subitems: SubMenuItem[]): boolean => {
    return subitems?.some(
      (subitem) => location.pathname === `/${subitem.route}`
    );
  };

  useEffect(() => {
    const newExpandedItems: { [key: number]: boolean } = { ...expandedItems };
    menuItems.forEach((item, index) => {
      if (item.subitems && isSubrouteActive(item.subitems)) {
        newExpandedItems[index] = true;
      }
    });
    setExpandedItems(newExpandedItems);
  }, [location.pathname]);

  const toggleExpanded = (index: number) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleItemClick = (item: MenuItem, index: number): void => {
    if (item.subitems) {
      toggleExpanded(index);
    } else {
      navigate(item.route || "");
    }
  };

  const menuItems: MenuItem[] = [
    {
      icon: "house",
      label: "Home",
      route: "",
      active: location.pathname === "/home",
    },
    {
      icon: "clipboard-data",
      label: "Estado General",
      route: "estado_general",
      active: location.pathname === "/estado_general",
    },
    {
      icon: "stopwatch",
      label: "Cron",
      route: "cron",
      active: location.pathname === "/cron",
    },
    {
      icon: "ticket-perforated",
      label: "Cupos",
      route: "cupos",
      active: location.pathname === "/cupos",
    },
    {
      icon: "sliders2",
      label: "Parámetros",
      route: "parametros",
      active: location.pathname === "/parametros",
    },
    {
      icon: "person-circle",
      label: "Alumnos",
      route: "alumnos",
      active: location.pathname === "/alumnos",
    },
    {
      icon: "card-heading",
      label: "Cursos",
      route: "cursos",
      active: location.pathname === "/cursos",
    },
    {
      icon: "toggles",
      label: "Validaciones",
      route: "validaciones",
      active: location.pathname === "/validaciones",
    },
    /* {
      icon: "envelope",
      label: "Colas",
      route: "colas",
      active: location.pathname === "/colas",
    }, */
    {
      icon: "hdd-stack",
      label: "Estado Servicios",
      route: "services",
      active: location.pathname === "/services",
    },
    {
      icon: "newspaper",
      label: "Novedades",
      route: "novedades",
      active: location.pathname === "/novedades",
    },
    {
      icon: "newspaper",
      label: "Novedades Masivas",
      route: "novedades-masivas",
      active: location.pathname === "/novedades-masivas",
    },
    {
      icon: "calendar",
      label: "Novedades Programadas",
      route: "novedades-programadas",
      active: location.pathname === "/novedades-programadas",
    },
    {
      icon: "journal-text",
      label: "Transacciones",
      active: [
        "/transacciones",
        "/reservas",
        "/inscripciones",
        "/desinscripciones",
      ].includes(location.pathname),
      subitems: [
        {
          icon: "journal-text",
          label: "TX",
          route: "transacciones",
          active: location.pathname === "/transacciones",
        },
        {
          icon: "journal-text",
          label: "TX Fallidas",
          route: "reservas",
          active: location.pathname === "/reservas",
        },
        {
          icon: "journal-text",
          label: "Inscripciones en Transito",
          route: "inscripciones",
          active: location.pathname === "/inscripciones",
        },
        {
          icon: "journal-text",
          label: "Desinscripciones en Transito",
          route: "desinscripciones",
          active: location.pathname === "/desinscripciones",
        },
      ],
    },
    {
      icon: "hdd-network",
      label: "Log",
      route: "log",
      active: location.pathname === "/log",
    },
    {
      icon: "hdd-network",
      label: "Eventos",
      route: "eventos",
      active: location.pathname === "/eventos",
    },
  ];

  return (
    <>
      <div
        className={`${
          sidebarOpen ? "sidebar active" : "sidebar"
        } flex-col bg-white`}
      >
        <img src={Logo} className="logo mt-4" />
        <div className="entorno mt-2">
          {entorno}-v{version}
        </div>
        <div className="buttonsContainer overflow-auto">
          {menuItems.map((item, index) => (
            <div key={index} className="mt-2 mb-2 ml-[20px]">
              <button
                className={`linkButton ${item.active ? "active" : ""} w-full`}
                onClick={() => handleItemClick(item, index)}
              >
                <h1 className="pl-3 flex flex-row items-center justify-between">
                  <div className="flex flex-row items-center">
                    <SlIcon
                      name={item.icon as string}
                      className="sidebar-icon"
                    />
                    {item.label}
                  </div>
                  {item.subitems && (
                    <SlIcon
                      name={
                        expandedItems[index] ? "chevron-up" : "chevron-down"
                      }
                      className="text-sm"
                    />
                  )}
                </h1>
              </button>

              {item.subitems && expandedItems[index] && (
                <div className="ml-4">
                  {item.subitems.map((subitem, subIndex) => (
                    <button
                      key={subIndex}
                      className={`linkButtonSubitem ${
                        subitem.active ? "active" : ""
                      } mt-1 mb-1 text-sm`}
                      onClick={() => navigate(subitem.route || "")}
                    >
                      <h1 className="pl-3 flex flex-row items-center">
                        <SlIcon
                          name={subitem.icon as string}
                          className="sidebar-icon text-sm"
                        />
                        {subitem.label}
                      </h1>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Sidebar;
